import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const featuredTestimonials = [{
    name: 'Mariana G.',
    age: '42 años',
    image: 'https://cdn.magicpatterns.com/uploads/gigyyZNjxczJUXVz7QAw9u/ChatGPT_Image_1_mar_2026,_23_26_42.png',
    text: 'Después de los 40 me sentía inflamada y sin energía todo el tiempo. Con RESET CORPORAL 30D bajé 4 kg en un mes y, lo más importante, dejé de sentir el abdomen pesado. Es simple, estructurado y fácil de seguir incluso trabajando todo el día.'
  }, {
    name: 'Carlos M.',
    age: '51 años',
    image: 'https://cdn.magicpatterns.com/uploads/kTuenr9zwK7Pze1XbLzaxD/ChatGPT_Image_1_mar_2026,_23_26_39.png',
    text: 'Después de los 50 el peso ya no se va tan fácil. Con RESET CORPORAL 30D bajé casi 5 kg en un mes sin hacer locuras ni dejar de trabajar todo el día. Me siento más liviano, con más energía y mucho menos inflamado.'
  }];
  const testimonials = [{
    name: 'Carla M.',
    age: '34 años',
    city: 'Buenos Aires',
    text: 'Perdí 4.5 kg en 30 días sin pasar hambre. El sistema es tan claro que no tuve que pensar qué hacer cada día. Mi ropa me queda increíble ahora.'
  }, {
    name: 'Romina L.',
    age: '29 años',
    city: 'Córdoba',
    text: 'Siempre empezaba dietas los lunes y las dejaba el miércoles. Con RESET CORPORAL 30D por primera vez completé un programa entero. La estructura lo cambia todo.'
  }, {
    name: 'Alejandro P.',
    age: '41 años',
    city: 'Rosario',
    text: 'Trabajo 10 horas al día y pensé que no iba a poder. Las rutinas de 20 minutos y las recetas rápidas fueron perfectas para mi ritmo de vida.'
  }, {
    name: 'Daniela S.',
    age: '37 años',
    city: 'Mendoza',
    text: 'La ansiedad nocturna era mi peor enemiga. El Tomo 3 me dio herramientas que uso todos los días. Bajé 3.8 kg y duermo mucho mejor.'
  }, {
    name: 'Facundo R.',
    age: '32 años',
    city: 'La Plata',
    text: 'No es una dieta más. Es un sistema que entendí desde el día 1. Menos hinchazón, más energía y mi abdomen se nota completamente diferente.'
  }];
  const quotes = ['En 3 semanas la inflamación bajó muchísimo. Mi ropa volvió a quedarme cómoda.', 'Por primera vez no sentí ansiedad constante. Tener estructura lo cambió todo.', 'No es otra dieta. Es un sistema que realmente puedo repetir.'];
  return <section className="py-16 px-4 bg-gray-100 border-y border-gray-200" data-id="element-264">
      <div className="max-w-5xl mx-auto" data-id="element-265">
        <div className="text-center mb-12" data-id="element-266">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-267">
            Lo que dicen quienes ya hicieron su Reset
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto" data-id="element-268"></div>
        </div>

        {/* Featured Testimonials with Images */}
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-269">
          {featuredTestimonials.map((t, idx) => <div key={idx} className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden" data-id="element-270">
              <img src={t.image} alt={`${t.name} - Antes y Después`} className="w-full h-48 sm:h-56 object-cover object-top" data-id="element-271" />
              <div className="p-6" data-id="element-272">
                <div className="flex items-center justify-between mb-3" data-id="element-273">
                  <div data-id="element-274">
                    <h4 className="font-bold text-gray-900 text-lg" data-id="element-275">
                      {t.name}
                    </h4>
                    <p className="text-sm text-gray-500" data-id="element-276">{t.age}</p>
                  </div>
                  <div className="flex" data-id="element-277">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-278" />)}
                  </div>
                </div>
                <p className="text-gray-700 text-base leading-relaxed" data-id="element-279">
                  "{t.text}"
                </p>
              </div>
            </div>)}
        </div>

        {/* Highlighted Quotes */}
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-280">
          {quotes.map((quote, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-md border-t-4 border-yellow-400 text-center" data-id="element-281">
              <div className="flex justify-center mb-3" data-id="element-282">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-283" />)}
              </div>
              <p className="text-lg font-bold text-gray-800 italic" data-id="element-284">
                "{quote}"
              </p>
            </div>)}
        </div>

        {/* Detailed Testimonials */}
        <div className="grid md:grid-cols-2 gap-6" data-id="element-285">
          {testimonials.map((t, idx) => <div key={idx} className={`bg-white p-8 rounded-xl shadow-lg border border-gray-200 ${idx === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-286">
              <div className="flex items-center mb-4" data-id="element-287">
                <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center text-xl font-bold text-gray-500 mr-4" data-id="element-288">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-289">
                  <h4 className="font-bold text-gray-900 text-lg" data-id="element-290">{t.name}</h4>
                  <p className="text-sm text-gray-500" data-id="element-291">
                    {t.age} | {t.city}
                  </p>
                </div>
                <div className="ml-auto flex" data-id="element-292">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-293" />)}
                </div>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed" data-id="element-294">
                "{t.text}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}